import computeScrollIntoView from 'compute-scroll-into-view';
export function scrollIntoView(item, list, items) {
  if (!item) {
    return;
  }

  var previousItem = items[Math.max(0, items.indexOf(item) - 1)];
  var previousItemTop = previousItem.offsetTop - list.current.scrollTop;
  var hasStickyHeader = item.parentElement.querySelectorAll('[data-sticky-header]').length > 0;
  var actions = computeScrollIntoView(item, {
    boundary: list,
    block: 'nearest',
    scrollMode: 'always'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
    var previousItemScrollAmount = item.getAttribute('data-option-index') === '0' ? 0 : previousItem.offsetTop;
    el.scrollTop = hasStickyHeader && previousItemTop <= 0 ? previousItemScrollAmount : top;
    el.scrollLeft = left;
  });
}